
import * as actionTypes from '../actions/actionTypes';

const INITIAL_STATE = {
    loading: false,
    faceObjects: {
        showMode: "none",
        showOverlay: false,
        faceRecognize: {},
        faceSubjects: {},
        faceEdit: {},
        faceAdd: {},
        faceDelete: {},
        faceCollections: {}
    },
    faceUploadObjects: null
}

const FaceReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case actionTypes.FACE_UPDATE_FACEOBJECTS_START:
            return { loading: true };
        case actionTypes.FACE_UPDATE_FACEOBJECTS_SUCCESS:
            return { loading: false, faceObjects: { ...state.faceObjects, ...action.payload } }
        case actionTypes.FACE_SET_LOADING:
            return { ...state, loading: action.payload }
        case actionTypes.FACE_UPLOAD_START:
            return { ...state, faceUploadObjects: action.payload }
        case actionTypes.FACE_SET_INIT_FACEOBJECTS:
            return { ...INITIAL_STATE };
        default:
            return state;
    }
}

export default FaceReducer;